import { render, staticRenderFns } from "./Organizer.vue?vue&type=template&id=1544383f&"
import script from "./Organizer.vue?vue&type=script&lang=js&"
export * from "./Organizer.vue?vue&type=script&lang=js&"
import style0 from "./Organizer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports